import { msg } from '@lingui/core/macro';

import { TQuestionDef } from './types';

export const QUESTIONS: TQuestionDef[] = [
  {
    id: 'registered2m',
    kind: 'choice',
    icon: 'building',
    eyebrow: msg`Business activity`,
    title: msg`Has your company been registered in Germany for at least 2 months?`,
    choices: [
      { value: 'yes', label: msg`Yes` },
      { value: 'no', label: msg`No` },
    ],
  },
  {
    id: 'schufaScore',
    kind: 'number',
    icon: 'shield',
    eyebrow: msg`Creditworthiness`,
    title: msg`What is your SCHUFA score?`,
    help: msg`The SCHUFA base score is between 0 and 10,000.`,
    placeholder: msg`e.g. 9,500`,
    suffix: msg`out of 10,000`,
    min: 0,
    max: 10000,
    rangeError: msg`The SCHUFA score is between 0 and 10,000.`,
    info: {
      text: msg`How to find your score: once a year you can get a free copy of your data directly from SCHUFA.`,
      link: msg`Get your SCHUFA score for free`,
      href: 'https://www.meineschufa.de/de/datenkopie',
    },
  },
  {
    id: 'revenueOver22k',
    kind: 'choice',
    icon: 'chart',
    eyebrow: msg`Revenue`,
    title: msg`Does your company have more than €22,000 in annual revenue?`,
    choices: [
      { value: 'yes', label: msg`Yes` },
      { value: 'no', label: msg`No` },
    ],
  },
  {
    id: 'crefoIndex',
    kind: 'number',
    icon: 'star',
    eyebrow: msg`Credit index`,
    title: msg`What is your credit index (Creditreform index)?`,
    help: msg`The Creditreform credit index ranges from 100 to 600.`,
    placeholder: msg`e.g. 200`,
    suffix: msg`(100–600)`,
    min: 100,
    max: 600,
    rangeError: msg`The Creditreform index is between 100 and 600.`,
    info: {
      text: msg`How to find your index: you can get your own business credit report (self-disclosure) directly from Creditreform.`,
      link: msg`Get your credit index from Creditreform`,
      href: 'https://www.creditreform.de/loesungen/bonitaet-risikomanagement/selbstauskunft',
    },
  },
];

export const TOTAL = QUESTIONS.length;

export const getQuestionById = (id: string): TQuestionDef | undefined =>
  QUESTIONS.find((question) => question.id === id);
